import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Anchor, Banner, Button, Dialogue, Text} from '@albert-io/atomic';
import {pluralize} from 'lib/stringUtils';

import '../invite-by-email.scss';

const IBEConfirmEmails = ({
  classroomId,
  handleClose,
  invalidEmails,
  validEmails,
  onConfirm,
  onBackBtnClick,
  ...rest
}) => {
  return (
    <Dialogue handleClose={handleClose} title='Confirm Recipients' {...rest}>
      <Dialogue.Body>
        {!validEmails.isEmpty() && (
          <>
            <Banner className='mb-x2' dismissable={false}>
              Invitations will be sent to the following recipients:
            </Banner>
            <ul className='ibe-email-list mb-x4 overflow-y-auto overscroll-contain'>
              {validEmails.sort().map((email) => (
                <li key={email}>{email}</li>
              ))}
            </ul>
          </>
        )}
        {!invalidEmails.isEmpty() && (
          <>
            <Banner className='mb-x2' dismissable={false}>
              You have already invited the recipients below:
            </Banner>
            <ul className='mb-x2'>
              {invalidEmails.sort().map((email) => (
                <li key={email}>{email}</li>
              ))}
            </ul>
            <Text as='p'>
              You can view and re-send invitations&nbsp;
              <Anchor onClick={handleClose} to={`/classes/${classroomId}/people/students/invited`}>
                here
              </Anchor>
              .
            </Text>
          </>
        )}
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button color='secondary' onClick={onBackBtnClick}>
          Back
        </Button>
        <Button disabled={validEmails.size === 0} onClick={onConfirm}>
          {`Send ${validEmails.size} ${pluralize('invitation', validEmails.size)}`}
        </Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

IBEConfirmEmails.propTypes = {
  classroomId: PropTypes.string,
  handleClose: PropTypes.func,
  invalidEmails: ImmutablePropTypes.list,
  validEmails: ImmutablePropTypes.list,
  onBackBtnClick: PropTypes.func,
  onConfirm: PropTypes.func
};

export default IBEConfirmEmails;
